<div class="d-flex align-items-center">
    <ng-select name="breedingMethod" id="breedingMethod" style="flex: 1;"
               bindValue="id"
               bindLabel="text"
               [(ngModel)]="selectedBreedingMethodId"
               [items]="items"
               [disabled]="disabled"
               [virtualScroll]="true"
               (ngModelChange)="onValueChanged($event)"
               (open)="search(select.searchTerm)"
               (scrollToEnd)="fetchMore(select.searchTerm)"
               (search)="onSearch(select.searchTerm)"
               (clear)="search(select.searchTerm)"
               [class]="customClass"
               (blur)="onBlur()"
               (keydown)="onKeyDown($event)"
               [appendTo]="appendTo"
               dropdownPosition="auto"
               #select>
    </ng-select>
    <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
</div>
<div class="row mt-2">
    <div *ngIf="showMethodTypeFilterSection" class="col-xs-12 col-md-12">
        <div *ngIf="showGenerativeMethodTypesOption" class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="methodType" id="methodTypeGenerative"
                   [(ngModel)]="selectedBreedingMethodFilterTypeValue"
                   [value]="BreedingMethodFilterTypeEnum.GENERATIVE_ONLY"
                   [disabled]="disableMethodTypeFilterSection"
                   (change)="onBreedingMethodFilterTypeValueChanged()">
            <label class="form-check-label" for="methodTypeGenerative" jhiTranslate="breeding-methods-select.filter.option.generative">Generative methods</label>
        </div>
        <div *ngIf="showDerivativeMethodTypesOption" class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="methodType" id="methodTypeDerivative"
                   [(ngModel)]="selectedBreedingMethodFilterTypeValue"
                   [value]="BreedingMethodFilterTypeEnum.DERIVATIVE_AND_MAINTENANCE_ONLY"
                   [disabled]="disableMethodTypeFilterSection"
                   (change)="onBreedingMethodFilterTypeValueChanged()">
            <label class="form-check-label" for="methodTypeDerivative" jhiTranslate="breeding-methods-select.filter.option.derivative-and-mantenance">Derivative and Maintenance methods</label>
        </div>
        <div *ngIf="showAllMethodTypesOption" class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="methodType" id="methodTypeAll"
                   [(ngModel)]="selectedBreedingMethodFilterTypeValue"
                   [value]="BreedingMethodFilterTypeEnum.ALL_METHODS"
                   [disabled]="disableMethodTypeFilterSection"
                   (change)="onBreedingMethodFilterTypeValueChanged()">
            <label class="form-check-label" for="methodTypeAll" jhiTranslate="breeding-methods-select.filter.option.all-methods">All methods</label>
        </div>
    </div>
	<div *ngIf="showFavoritesCheckbox" class="col-xs-12 col-md-12">
		<div class="form-check form-check-inline">
			<input type="checkbox" class="form-check-input" name="useFavoriteBreedingMethods" id="useFavoriteBreedingMethods"
				   [(ngModel)]="selectedUseFavoriteBreedingMethods" [disabled]="disableFavoritesCheckbox">
			<label class="form-check-label" for="useFavoriteBreedingMethods" jhiTranslate="breeding-methods-select.use-favorite">
			</label>
		</div>
	</div>
</div>
